export var FULLSTORY_EXCLUDE_CLASS = 'fs-exclude';
//# sourceMappingURL=constants.js.map